import React from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setToken } from "../../../redux/actions/auth/token";
import { GET_PROPERTY_LIST, LOGIN_AUTH } from "../../../redux/actionTypes/actionsTypes";
import { isAmppa } from "../../../utils/isAmppa";
import { getAmpStatus } from "../../../redux/actions/ampStatus/status";
import { changeIsCloseable, changeModalContent, changeModalState } from "../../../redux/actions/modal/modal";
import AmpSurvey, { AmpSurveyTitle } from "../AmpSurvey/AmpSurvey";

export default function SignOut(): JSX.Element {
    const { user_profile_id, username } = useParams();
    const dispatch = useDispatch();
    // const { i18n } = useTranslation();

    // Remove auth token
    const storageFontSize = window.localStorage.getItem("ampFontSize");
    const showSurvey = localStorage.getItem("showSurvey");
    const userProfileId = localStorage.getItem("userProfileId");
    const surveyId = localStorage.getItem("surveyId");

    window.localStorage.clear();
    if(showSurvey)
        window.localStorage.setItem("showSurvey", showSurvey);
    if (storageFontSize) {
        window.localStorage.setItem("ampFontSize", storageFontSize);
    }
    if(userProfileId || surveyId) {
        window.localStorage.setItem("surveyId", (userProfileId || surveyId)  as string)
    }
    if (user_profile_id !== undefined && username !== undefined && user_profile_id !== "undefined" && username !== "undefined") {
        window.localStorage.setItem("verifyInfo", `${user_profile_id}/${username}`)
    }

    // Tell app that there is no longer a token
    // Note: this could be done with an event listener but react does not like that
    dispatch(setToken(false));
    
    // i18n.changeLanguage("en");    

    // Reset the login store so it doesn't think we're still logged in
    dispatch({
        type: LOGIN_AUTH.SUCCESS,
        payload: {tip: false, token: null, user_profile_id: null, success: false, reset_req: false },
    })

    if ( isAmppa ) {
        localStorage.setItem("acceptedToc", "yes");
        localStorage.setItem("statusClosed", "0");
        dispatch({type:GET_PROPERTY_LIST.RESET});
        dispatch(getAmpStatus());
    }

    if (showSurvey === "Y") {
        dispatch(changeModalState("modal-fade-in"));
        dispatch(changeIsCloseable(false));
        dispatch(changeModalContent(
        <AmpSurvey userProfileId={userProfileId}/>,
            <AmpSurveyTitle/>,
            "test text",

        ));
    }

    return <></>
}